'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiLocationOutline = function TiLocationOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 8.3c2.7 0 5.2 1.1 7.1 2.9 1.9 1.9 2.9 4.3 2.9 6.9s-1 5.1-2.9 6.9l-7.1 7-7.1-7c-1.9-1.8-2.9-4.3-2.9-6.9s1-5 2.9-6.9c1.9-1.8 4.4-2.9 7.1-2.9z m0-3.3c-3.4 0-6.8 1.3-9.4 3.8-5.2 5.2-5.2 13.5 0 18.6l9.4 9.3 9.4-9.3c5.2-5.1 5.2-13.4 0-18.6-2.6-2.5-6-3.8-9.4-3.8z m0 9.2c1.1 0 2.2 0.4 2.9 1.2 1.7 1.6 1.7 4.3 0 5.9-0.7 0.8-1.8 1.2-2.9 1.2s-2.2-0.4-2.9-1.2c-1.7-1.6-1.7-4.3 0-5.9 0.7-0.8 1.8-1.2 2.9-1.2z m0-1.7c-1.5 0-3 0.6-4.1 1.7-2.3 2.3-2.3 6 0 8.3 1.1 1.1 2.6 1.7 4.1 1.7s3-0.6 4.1-1.7c2.3-2.3 2.3-6 0-8.3-1.1-1.1-2.6-1.7-4.1-1.7z' })
        )
    );
};

exports.default = TiLocationOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/location-outline.js
// module id = 3643
// module chunks = 0